import { Link } from 'react-router-dom';


export default function CTASection() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b1f1b06be3624dac8df9e96111612758.jpg"
          alt="MRS Team"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1E3A5F]/95 via-[#1E3A5F]/80 to-[#1E3A5F]/60"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
        <span className="inline-flex items-center gap-2 bg-[#DC2626] text-white text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest mb-6">
          <i className="ri-alarm-warning-fill"></i>
          Available 24/7
        </span>
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          Need Emergency Restoration Services?
        </h2>
        <p className="text-white/70 text-base md:text-lg mb-10 max-w-xl mx-auto">
          Our certified team is standing by around the clock to respond to your emergency and begin the restoration process immediately.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:+18005551234"
            className="inline-flex items-center justify-center gap-2 bg-[#DC2626] text-white px-10 py-4 rounded-full font-semibold text-sm hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill"></i>
            Call Now: +1 (800) 555-1234
          </a>
          <Link
            to="/service-request"
            className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-10 py-4 rounded-full font-semibold text-sm hover:bg-white hover:text-[#1E3A5F] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-list-3-fill"></i>
            Request Service Online
          </Link>
        </div>

        {/* Certifications */}
        <div className="mt-14 flex flex-wrap items-center justify-center gap-8">
          {[
            { icon: 'ri-shield-check-fill', label: 'IICRC Certified' },
            { icon: 'ri-award-fill', label: 'Licensed & Insured' },
            { icon: 'ri-building-fill', label: 'BBB Accredited' },
            { icon: 'ri-leaf-fill', label: 'EPA Certified' },
            { icon: 'ri-customer-service-fill', label: '24/7 Support' },

          ].map((cert) => (
            <div key={cert.label} className="flex items-center gap-2 text-white/70">
              <i className={`${cert.icon} text-[#DC2626] text-lg`}></i>
              <span className="text-sm font-medium">{cert.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
